import {
  ARIA_DROPDOWN_LABEL,
  ARIA_DROPDOWN_MENU_ITEM,
  ARIA_DROPDOWN_SELECT,
  FORM_CONTROL_ID,
  LABEL_ID,
  VIEW_MODE_CONTAINER_ID,
} from '../constants/locators';

type UseDropdownLocatorProps = {
  key: string;
};

export const useDropdownLocators = ({ key }: UseDropdownLocatorProps) => {
  return {
    formControlNodeId: `${FORM_CONTROL_ID}--${key}`,
    viewModeContainerNodeId: `${VIEW_MODE_CONTAINER_ID}--${key}`,
    labelNodeId: `${LABEL_ID}--${key}`,

    ariaDropdownLabel: `${ARIA_DROPDOWN_LABEL}--${key}`,
    ariaDropdownSelect: `${ARIA_DROPDOWN_SELECT}--${key}`,
    ariaDropdownMenuItem: `${ARIA_DROPDOWN_MENU_ITEM}--${key}`,
  };
};
